<template>
  <v-card v-role="'ped'"
    style="margin:auto;width:650px;margin-top:50px;"
  >
 <v-card-title>
          <span class="text-h5">Cadastro de nova Instituição</span>
        </v-card-title>
 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
 <template>
                 <!-- <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col> -->

              </template>
               
 <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card-text>
      <v-row>
<v-col  cols="12" md="12">
            <!-- <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.nomeInstituicao"
             label="Nome da Instituição"
            ></v-text-field> -->
          <v-combobox
            v-model="instituicaoSelected"
            :items="instituicoes"
            item-text="descricao"
            label="Selecione a instituição"
            outlined
            return-object
            :rules="ruleTextRequired"
        ></v-combobox>
          </v-col>
    <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleTextRequired"
             v-model="editedItem.sigla"
             label="Sigla da Instituição"
            ></v-text-field>
          </v-col>
      <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleTextRequired"
            v-model="editedItem.nomeUsuario"
             label="Usuario Principal"
            ></v-text-field>
          </v-col>
          <v-col  cols="12" md="6">
            <v-text-field
            :rules=" ruleEmailRequired"
            v-model="editedItem.emailUsuario"
             label="Email do usuario Principal"
            ></v-text-field>
          </v-col>
      <v-col  cols="12" md="6">
            <v-text-field
            :rules="ruleRequired"
            v-model="editedItem.telefoneUsuario"
             label="Telefone do Usuario Principal"
            ></v-text-field>
          </v-col>
           <v-col cols="12" md="6">
             <v-combobox
              v-model="imsSelected"
              item-text="descricao"
              item-value="descricao"
              :items="IMSAssociados"
              label="Selecione o IMS associado"
               outlined
               :rules="ruleRequired"
            ></v-combobox>
           </v-col>
          <v-col cols="12" md="4">
                      <v-text-field
                        required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" md="1">
                      <v-switch   @change="outroDoc()"></v-switch>
                    </v-col>
           </v-row>
    </v-card-text>
    </v-form>
    <v-card-actions>
          <v-spacer></v-spacer>
           
         <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
        </v-card-actions>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  directives: { mask },
  data: () => ({
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleEmailRequired: [
        value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos e',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    ruleTelefone: [
      value => value.length === 9 || 'Minimo de caracteres exigido( 9 ).'
    ],
    ruleBI: [
    value => !!value || 'Required.',
      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    aberturaFecho: [],
    imsSelected: null,
    IMSAssociados: [
        {id:1, descricao:'IMS-Luanda'},
        {id:2, descricao:'IMS-Kalawenda'} 
    ],
    isLoading: false,
    valid: true,
    overlay:false,
    instituicaoSelected: null,
    instituicoes:[],
    habilitaBi: false,
    editedItem: {
      nomeInstituicao: '',
      sigla: '',
      nomeDg: '',
      telefoneDg: '',
      nomeDp: '',
      telefoneDp: '',
      emailDg: '',
      emailDp: '',
      nomeUsuario: '',
      emailUsuario: '',
      telefoneUsuario: '',
      bi: null

    },
    defaultItem: {
      nomeInstituicao: '',
      sigla: '',
      nomeDg: '',
      telefoneDg: '',
      nomeDp: '',
      telefoneDp: '',
      emailDg: '',
      emailDp: '',
      nomeUsuario: '',
      emailUsuario: '',
      telefoneUsuario: '',
      bi: null
    },
    mascara: '#########-AA-###',
    descricao: 'Nº do Bi'
  }),
  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlgêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
   // if ((ls.get('i_id') === 7 || ls.get('i_id') === 1 )) { 
      this.getInstituicoes()
   // }
   // else
    //  this.$router.push('denied')
    
  },

  methods: {

    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          value => (value.length >= 16 && value.length <= 30) || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    },


    async getInstituicoes () {
      try {
        this.instituicoes = await axios
          .get('/ObterInstituicoesConfig')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async save () {

      if(this.$refs.form.validate()) {

      this.overlay = true
      let dados = {
        idInstituicaoP: 0,
        descricaoP: (this.instituicaoSelected.descricao === undefined || this.instituicaoSelected.descricao === null)?this.instituicaoSelected:this.instituicaoSelected.descricao,
        siglaP: this.editedItem.sigla,
        nomeDgP: this.editedItem.nomeDg,
        emailDgP: this.editedItem.emailDg,
        telefoneDgP: this.editedItem.telefoneDg,
        nomeDpP: this.editedItem.nomeDp,
        emailDpP: this.editedItem.emailDp,
        telefoneDpP: this.editedItem.telefoneDp,
        userMainP: this.editedItem.nomeUsuario,
        emailUserP: this.editedItem.emailUsuario,
        telefoneUserP: this.editedItem.telefoneUsuario,
        autor: ls.get('nomeUsuario'),
        idanolectivo: ls.get('idanolectivo'),
        idPEssoa: this.editedItem.bi,
        imsAssociado: this.imsSelected.descricao
      }

      try {
        // eslint-disable-next-line no-unused-vars
        if(!this.instituicaoSelected.idInstituicao){
            var  result = await axios.post('/cadastrarInstituicaoTbConfiguracoes', dados).then(res => res.data)
            var arrr1 = result[0]
            var arrr2 = arrr1[0].idinstituicao
         }else{
            var arrr2 = this.instituicaoSelected.idInstituicao
         }
        if(arrr2 >0){// Apois inserir na base de dados de configuração, vai inserir nas duas bases da applicaão
             dados.idInstituicaoP = arrr2 // Atribuição do idinstituição
             let resultApp1 = await axios.post('/cadastrarInstituicaoLocal', dados).then(res => res.data);
             let resultApp2 = await axios.post('/cadastrarInstituicaoOutside', dados).then(res => res.data);

            if(resultApp1.last_insert_id >=1 &&  resultApp2.last_insert_id >= 1){
              Swal.fire('Informação','Instituição cadastrada com sucesso','success')
              this.limpar()
            }else{
              Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
            }

        }else{
           Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
        }
        this.overlay = false
        } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
      }
    },
    limpar () {
      this.isLoading = false
      this.$refs.form.reset()
    }
  }
}

</script>
